
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 220 220"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('g',{attrs:{"id":"Press"}},[_c('circle',{attrs:{"cx":"110","cy":"110","r":"110","fill":"#5e256f"}}),_c('path',{staticClass:"cls-2",attrs:{"fill":"#fff","d":"M87.11 127.63a7.64 7.64 0 117.64-7.63 7.64 7.64 0 01-7.64 7.63zm0-11.27a3.64 3.64 0 103.64 3.64 3.64 3.64 0 00-3.64-3.64z"}}),_c('path',{staticClass:"cls-2",attrs:{"fill":"#fff","d":"M87.11 136.42A16.43 16.43 0 11103.54 120a16.44 16.44 0 01-16.43 16.42zm0-28.86A12.43 12.43 0 1099.54 120a12.44 12.44 0 00-12.43-12.44z"}}),_c('path',{staticClass:"cls-2",attrs:{"fill":"#fff","d":"M152 140.66h-42.53v-2a38.86 38.86 0 00-15.73-31.14l2.37-3.22a42.88 42.88 0 0117.31 32.36H148c-.73-16.22-10.35-29.1-22.06-29.1v-4c14.4 0 26.11 15.75 26.11 35.1zM87.11 98.77a7.64 7.64 0 117.64-7.64 7.64 7.64 0 01-7.64 7.64zm0-11.27a3.64 3.64 0 103.64 3.63 3.64 3.64 0 00-3.64-3.63z"}}),_c('path',{staticClass:"cls-2",attrs:{"fill":"#fff","d":"M87.11 107.56a16.43 16.43 0 1116.43-16.43 16.44 16.44 0 01-16.43 16.43zm0-28.85a12.43 12.43 0 1012.43 12.42 12.43 12.43 0 00-12.43-12.42zM125.9 107.56v-4a12.43 12.43 0 100-24.85v-4a16.43 16.43 0 110 32.85z"}}),_c('path',{staticClass:"cls-2",attrs:{"fill":"#fff","d":"M92.75 103.56h33.15v4H92.75zM87.11 74.71h38.79v4H87.11zM87.11 132.42h23.42v4H87.11z"}}),_c('path',{staticClass:"cls-2",attrs:{"fill":"#fff","d":"M163.11 168.82H60.44V46.54h102.67zm-98.67-4h94.67V50.54H64.44z"}})])])])])
          )
        }
      }
    